import { z, ZodIssueCode } from "zod";

/** Magyar alapértelmezett hibaüzenetek (api és web is betölti a shared csomaggal). */
const errorMap: z.ZodErrorMap = (issue, ctx) => {
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === "undefined" || issue.received === "null") return { message: "Kötelező mező" };
      return { message: "Érvénytelen érték" };
    case ZodIssueCode.too_small:
      // Üresen hagyott mezőnél a hossz-követelmény helyett az a lényeg, hogy ki kell tölteni.
      if (issue.type === "string") {
        const empty = typeof ctx.data === "string" && ctx.data.trim() === "";
        return { message: empty || issue.minimum === 1 ? "Kötelező mező" : `Legalább ${issue.minimum} karakter` };
      }
      if (issue.type === "array") return { message: `Legalább ${issue.minimum} elem kell` };
      return { message: `Legalább ${issue.minimum}` };
    case ZodIssueCode.too_big:
      if (issue.type === "string") return { message: `Legfeljebb ${issue.maximum} karakter` };
      return { message: `Legfeljebb ${issue.maximum}` };
    case ZodIssueCode.invalid_string:
      if (issue.validation === "email") return { message: "Érvénytelen e-mail cím" };
      if (issue.validation === "uuid") return { message: "Érvénytelen azonosító" };
      return { message: "Érvénytelen formátum" };
    case ZodIssueCode.invalid_enum_value:
      return { message: "Érvénytelen választás" };
    default:
      return { message: ctx.defaultError };
  }
};

z.setErrorMap(errorMap);
